module.exports = __webpack_public_path__ + "static/scale-model-of-old-joliet-prison-in-joliet-illinois-67f34e3070276f9ca6e62df3e131ec2f.png";